import { Icon, IconProps } from './Icon';

export type AirplayProps = IconProps;

export const Airplay = (props: AirplayProps) => (
  <Icon width="16px" height="16px" fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" {...props}>
    <path d="M3.333 12a2 2 0 0 1-2-2V5.2c0-1.12 0-1.68.218-2.108a2 2 0 0 1 .874-.874C2.853 2 3.413 2 4.533 2h6.934c1.12 0 1.68 0 2.108.218a2 2 0 0 1 .874.874c.218.428.218.988.218 2.108V10a2 2 0 0 1-2 2m-6.862 2h4.39c.363 0 .544 0 .636-.074a.333.333 0 0 0 .124-.264c-.002-.118-.118-.258-.35-.537L8.41 10.492c-.141-.17-.211-.254-.296-.284a.333.333 0 0 0-.228 0c-.085.03-.155.115-.296.284l-2.194 2.633c-.233.28-.35.419-.351.537-.002.102.044.2.124.264.091.074.273.074.636.074Z" stroke="currentcolor" strokeLinecap="round" strokeLinejoin="round"/>
  </Icon>
)
